export function createWorkerMessage(options, connectionId) {
  const workerMessage = Object.assign({}, options, {
    payload: options.payload || {},
    originConnectionId: connectionId
  });
  return workerMessage;
}